<div *ngIf="browserBlocked()" class="app">
  <span class="browser-error">{{browserInfo.blockReason}}</span>
</div>
<div *ngIf="!browserBlocked()" class="app">
  <div class="top-nav" *ngIf="showNavbar()">

    <button mat-button class="link avatar-container" [title]="maxNavbarLinks > 0 ? (memberToView ? memberToView.email : '') : 'Pages'"
      [disabled]="maxNavbarLinks > 0" (click)="showSettings()">
      <div class="avatar-button-container">
        <div class="inner-avatar-container">
          <div *ngIf="!memberToView" class="icon avatar-icon skeleton-animation"></div>
          <avatar *ngIf="memberToView" class="icon avatar-icon" [text]="memberToView.fullName" [url]="memberToView.photoUrl">
          </avatar>
        </div>
      </div>
    </button>
  
<!-- 
    <button  mat-button class="link avatar-container chat-button" (click)="openChat()"><img src="assets/chat.svg"/></button>  -->

    <div *ngIf="getUserTeams().length > 1" class="team-selector">
     <form [formGroup]="teamForm" *ngIf="showTeamSelector">
        <mat-form-field floatLabel="always">
          <mat-label>Showing schedule for</mat-label>
          <mat-select (selectionChange)="setCurrentTeam($event)" formControlName="currentTeam" name="currentTeam" [compareWith]="teamComparator">
            <mat-option *ngFor="let team of getUserTeams()" [value]="team">
              {{team.teamName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form> 
    </div>
  </div>
  <div class="navWrapper">
    <div *ngIf="showNavbar()" class="navbar" [ngClass]="{'no-links': maxNavbarLinks < 1}">
     <div  *ngIf="maxNavbarLinks > 0" class="logobar">
        <img class="huddylogo"   src="assets/logo.png"/>
        <!-- <button mat-button class="link avatar-container" [title]="maxNavbarLinks > 0 ? (memberToView ? memberToView.email : '') : 'Pages'"
          [disabled]="maxNavbarLinks > 0" (click)="showSettings()">
          <div class="avatar-button-container">
            <div class="inner-avatar-container">
              <div *ngIf="!memberToView" class="icon avatar-icon skeleton-animation"></div>
              <avatar *ngIf="memberToView" class="icon avatar-icon" [text]="memberToView.fullName" [url]="memberToView.photoUrl">
              </avatar>
            </div>
          </div>
        </button> -->
        <div class="beta-badge-container">
            <img src="assets/ic_beta_1.svg" class="beta-badge"/>
        </div>
    </div>
      <div class="links">
        <button *ngIf="maxNavbarLinks > 2" mat-button class="link" [ngClass]="{selected: checkRoute(resolveHome())}" (click)="tryToFollowLink(resolveHome())">
          <div class="button-container">
            <img src="assets/ic_home.svg"  class="icon"/>
            <div class="text">Home</div>
          </div>
        </button>
        <button *ngIf="maxNavbarLinks > 3" mat-button class="link" [ngClass]="{selected: checkRoute('families')}" (click)="tryToFollowLink('families')">
          <div class="button-container">
            <img src="assets/family.svg"  class="icon-bigger"/> 
            <div class="text">Families</div>
          </div>
        </button>
        <button *ngIf="resolveHome() === 'work-queue' && maxNavbarLinks > 3" mat-button class="link" [ngClass]="{selected: checkRoute('patients')}" (click)="tryToFollowLink('patients')">
          <div class="button-container">
            <img src="assets/patient_list.svg"  class="icon-bigger"/>
            <div class="text">Patients</div>
          </div>
        </button>
        <button *ngIf="maxNavbarLinks > 5" mat-button class="link" [ngClass]="{selected: checkRoute('compasses')}" (click)="tryToFollowLink('compasses')">
          <div class="button-container">
            <img src="assets/ic_compasses.svg"   class="icon"/>
            <span class="text">Compasses</span>
          </div>
        </button>
        <button *ngIf="maxNavbarLinks > 6" mat-button class="link" [ngClass]="{selected: checkRoute('builder')}" (click)="tryToFollowLink('builder')">
          <div class="button-container">
            <img src="assets/ic_builder.svg"   class="icon"/>
            <span class="text">Builder</span>
          </div>
        </button>
        <button *ngIf="maxNavbarLinks > 7" mat-button class="link" [ngClass]="{selected: checkRoute('settings')}" (click)="tryToFollowLink('settings')">
          <div class="button-container">
          <img src="assets/ic_settings.svg"   class="icon"/>
          <span class="text">Settings</span>
        </div>
        </button>
        <!-- <button *ngIf="maxNavbarLinks > 5" mat-button class="link" [ngClass]="{selected: checkRoute('profile')}" (click)="tryToFollowLink('profile')">
          <img src="assets/ic_team.svg" [ngClass]="{blackSVG2Primary: checkRoute('profile')}" class="icon"/>
          <span class="text">Profile</span>
        </button>
        <button *ngIf="maxNavbarLinks < 6" mat-button class="link" [ngClass]="{selected: maxNavbarLinks > 2 && settingsSelected()}" (click)="showSettings()">
          <img [src]="'assets/content-icon/ic-20.svg'" [ngClass]="{blackSVG2Primary: maxNavbarLinks > 2 && settingsSelected()}"
              class="icon rotated"/>
          <span class="text">More</span>
        </button>-->

      </div>
      <div *ngIf="maxNavbarLinks > 0" class="bottom-links">
        <div class="version">v {{getVersion()}}</div>
        <button *ngIf="maxNavbarLinks > 1" mat-button class="link"  (click)="showHelp()">
          <div class="button-container">
            <img [src]="'assets/ic_help.svg'" class="icon"/>
            <span class="text">Help Center</span>
          </div>
        </button> 
        <button mat-button class="link" (click)="logOut()">
          <div class="button-container">
            <img [src]="'assets/log-in-outline.svg'" class="icon"/>
            <span class="text">Sign out</span>
          </div>
        </button>
        </div>
    </div>
    <div class="popover" *ngIf="showingSettings" [style]="getPopoverVariables(maxNavbarLinks < 2 ? maxNavbarLinks - 1 : maxNavbarLinks - 2)">
      <div class="popover-inner-container">
        <div *ngIf="maxNavbarLinks < 3" class="popover-item" [ngClass]="{selected: checkRoute('providers')}" (click)="tryToFollowLink('providers')">
          <span class="text">Providers</span>
        </div>
        <div *ngIf="maxNavbarLinks < 4" class="popover-item" [ngClass]="{selected: checkRoute('compasses')}" (click)="tryToFollowLink('compasses')">
          <span class="text">Compasses</span>
        </div>
        <div *ngIf="maxNavbarLinks < 5" class="popover-item" [ngClass]="{selected: checkRoute('library')}" (click)="tryToFollowLink('library')">
          <span class="text">Library</span>
        </div>
        <div *ngIf="maxNavbarLinks < 6" class="popover-item" [ngClass]="{selected: checkRoute('profile')}" (click)="tryToFollowLink('profile')">
          <span class="text">Profile</span>
        </div>
        <div *ngIf="maxNavbarLinks < 2" class="popover-divider"></div>
        <div class="popover-item" *ngIf="maxNavbarLinks < 2">
          <a href="mailto:support@huddyhealth.com?subject=Desktop%20Support" target="_blank" class="text" (click)="clearPopover()">Contact support&#64;huddyhealth.com</a>
        </div>
        <div *ngIf="maxNavbarLinks < 2 && isValidRole('ROLE_COMPASS_REVIEW')" class="popover-item" [ngClass]="{selected: checkRoute('products')}" (click)="tryToFollowLink('products')">
          <span class="text">Manage products</span>
        </div>
        <span class="version">{{getVersion()}}</span>
      </div>
    </div>
    <div class="popover" *ngIf="showingHelp" [style]="getPopoverVariables(maxNavbarLinks - 1)">
      <div class="popover-inner-container">
        <div class="popover-item">
          <a href="mailto:support@huddyhealth.com?subject=Desktop%20Support" target="_blank" class="text" (click)="clearPopover()">Contact support&#64;huddyhealth.com</a>
        </div>
        <div *ngIf="isValidRole('ROLE_COMPASS_REVIEW')" class="popover-item" [ngClass]="{selected: checkRoute('products')}" (click)="tryToFollowLink('products')">
          <span class="text">Manage products</span>
        </div>
      </div>
    </div>
  </div>
  <div cdkScrollable class="page-container">
    <router-outlet></router-outlet>
  </div>
  <div class="navigateScrim" *ngIf="showingPopover()" (click)="clearPopover()"></div>
</div>
